import Vue from 'vue'
import { Form, FormItem, Input, Button, Message, Icon, Table, TableColumn, Tabs, Container, Header, Tooltip, Aside, Menu, Main, MenuItem, Card, Row, Col, Select, Option, TabPane, Dialog, Alert, Loading, Tag, Autocomplete, Upload, MessageBox, DatePicker, Switch, Pagination, RadioGroup, Radio, Link, Notification, Rate, CollapseTransition, Cascader, InputNumber } from 'element-ui'

Vue.use(Form)
Vue.use(FormItem);
Vue.use(Input)
Vue.use(Button)
Vue.prototype.$message = Message;
Vue.use(Icon);
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tabs)
Vue.use(Container)
Vue.use(Header)
Vue.use(Tooltip)
Vue.use(Aside)
Vue.use(Menu)
Vue.use(Main)
Vue.use(MenuItem)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Select)
Vue.use(Option)
Vue.use(TabPane)
Vue.use(Dialog)
Vue.use(Alert)
Vue.use(Loading)
Vue.use(Tag)
Vue.use(Autocomplete)
Vue.use(Upload)
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$alert = MessageBox.alert;
Vue.use(DatePicker)
Vue.use(Switch)
Vue.use(Pagination)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(Link)
Vue.prototype.$notify = Notification;
Vue.use(Rate)
Vue.use(CollapseTransition)
Vue.use(Cascader)
Vue.use(InputNumber)
Vue.prototype.$prompt = MessageBox.prompt;


Dialog.props.lockScroll.default = false;